export default __webpack_public_path__ + "static/media/Checklist.bd69026a.svg";